module.exports = __webpack_public_path__ + "fonts/Lato-HairlineItalic.30d5869e.eot";